import { useCallback, useMemo } from 'react'
import { useLocation, useSearchParams } from 'react-router'

export const useQuery = () => {
    const { search } = useLocation()

    return useMemo(() => new URLSearchParams(search), [search])
}

export const useUpdateQuery = () => {
    const [, setSearchParams] = useSearchParams()

    return useCallback(
        (param: string, value: string | null) => {
            setSearchParams(
                (prev) => {
                    const query = new URLSearchParams(prev)
                    if (value) {
                        query.set(param, value)
                    } else {
                        query.delete(param)
                    }
                    return query
                },
                { replace: true },
            )
        },
        [setSearchParams],
    )
}
